import React from "react";
import { bind } from "decko";
import orderBy from "lodash.orderby";
import { Pagination } from "react-bootstrap";

import ImageGoal from "../img/soccerball.svg";
import ImageSubstitution from "../img/substitution.png";
import ImageWhistle from "../img/whistle_black.png";
import ImageWhistleBorder from "../img/whistle_black_border.png";
import ImageYellowCard from "../img/yellowcard.png";
import ImageRedCard from "../img/redcard.png";
import ImageShot from "../img/shot_inverted.png";
import ImageMisc from "../img/more_dots_inverted.png";

import { listLoggedInServers } from "./include/Server";
import GameEvent from "./include/GameEvent";

const eventToImg = {
    'goal': ImageGoal,
    'start phase': ImageWhistle,
    'end phase': ImageWhistle,
    'free kick': ImageWhistleBorder,
    'penalty': ImageWhistleBorder,
    'corner': ImageWhistleBorder,
    'offside': ImageWhistleBorder,
    'end of game': ImageWhistle,
    'yellow card': ImageYellowCard,
    'red card': ImageRedCard,
    'shot': ImageShot,
    'substitution': ImageSubstitution,
};

function timeAgoString (date) {
    //Comparing with clientside clock should be avoided, consider alternate solution
    let seconds = Math.floor((new Date() - date) / 1000);

    if (seconds >= 172800) { //48 hours
        return "" + (seconds / 3600 / 24).toFixed(0) + "d";
    }
    if (seconds >= 3600) {
        return "" + (seconds / 3600).toFixed(0) + "h";
    }
    if (seconds >= 60) {
        return "" + (seconds / 60).toFixed(0) + "m";
    }
    return "" + seconds + "s";
}

export default class ClipList extends React.Component {
    constructor (props) {
        super(props);

        this.refreshFrequency = this.props.refreshFrequency || 5000;

        this.state = {
            clips: [],
            page: 1,
            maxPages: 1,
            filterTags: [],
            tagFilter: 'all',
            minRatingFilter: 1,
        };

        this.handleFilterTagChange = this.handleFilterTagChange.bind(this);
    }

    componentDidMount () {
        //Refresh list every second
        this.tick = setInterval(() => this.load(), this.refreshFrequency);
        this.load();
        if (this.props.eventFilteringEnabled) {
            this.loadTags();
        }
    }

    componentWillUnmount () {
        clearInterval(this.tick);
    }

    loadTags () {
        const servers = listLoggedInServers();

        if (servers.length === 0) {
            return;
        }

        const getTagsUrl = servers[0].createUrl("/tag/", {});
        servers[0].get(getTagsUrl, data => {
            let tags = ['all'];
            Object.keys(data.tags).forEach(function(key, index) {
                tags.push(key);
            });
            this.setState({'filterTags': tags});
        });
    }

    getStandardEventParams () {
        const date = this.props.date ? new Date(this.props.date) : new Date();
        date.setHours(0,0,0,0);
        const fromDate = date.toISOString();
        date.setHours(24);
        const toDate = date.toISOString();

        return {
            count: 99,
            from: (this.state.page-1) * 99,
            from_date: fromDate,
            to_date: toDate,
        };
    }

    loadAllEvents () {
        let servers = listLoggedInServers();
        let newClips = [];
        let maxPages = 1;
        let successCnt = 0;

        let params = this.getStandardEventParams();
        params = this.setExtraLoadParams(params);

        servers.forEach((server) => {
            const url = server.createUrl("/event/", params);
            server.get(url, data => {

                let pages = Math.ceil(data.total / params.count);
                maxPages = Math.max(pages, maxPages);
                newClips = newClips.concat(data.events.map((clip) => (
                        GameEvent.load(clip, server)
                    )).filter((e) => e !== null)
                );

                if (++successCnt === servers.length) {
                    this.setClips(newClips, Math.min(this.state.page, maxPages), maxPages)
                }
            });
        });
    }

    setClips (clips, page=1, maxPages=1) {
        clips = orderBy(clips, "timestamp", "desc");

        if (this.props.onLoadedClips) this.props.onLoadedClips(clips);

        this.setState({
            clips: clips,
            page: page,
            maxPages: maxPages,
        });
    }

    loadMatchEvents () {
        let params = {
            count: 999,
        };
        params = this.setExtraLoadParams(params);

        let filteredGames = this.props.filteredGames;
        if (!Array.isArray(filteredGames)) filteredGames = [filteredGames];
        else filteredGames = filteredGames.slice();

        let newClips = [];
        let successCnt = 0;
        filteredGames.forEach(({server, game}) => {
            const url = server.createUrl(`/game/${game.id}/events`, params);
            server.get(url, data => {

                newClips = newClips.concat(data.events.map((clip) => (
                        GameEvent.load(clip, server)
                    )).filter((e) => e !== null)
                );

                if (++successCnt === filteredGames.length) {
                    this.setClips(newClips);
                }
            });
        });
    }

    setExtraLoadParams (params) {

        params.nocache = true;

        if (this.props.statusLevel) params.status = this.props.statusLevel;

        if (this.props.eventFilteringEnabled) {
            if (!!this.state.tagFilter && this.state.tagFilter !== 'all') {
                params['tags'] = '[{"action": "' + this.state.tagFilter + '"}]';
            }
            if (this.state.minRatingFilter && this.state.minRatingFilter > 1) {
                params['min_rating'] = this.state.minRatingFilter;
            }
        }
        return params;
    }

    load () {
        if (this.props.filteredGames) {
            this.loadMatchEvents();
        } else {
            this.loadAllEvents();
        }
    }

    forceRefresh () {
        clearInterval(this.tick);
        this.tick = setInterval(() => this.load(), this.refreshFrequency);
        this.load();
    }

    @bind
    formatClip (clip) {

        const missingExpectedFields = clip.getMissingExpectedFields();
        const tagAction = clip.tag.action;
        const rating = clip.playlist.rating;

        let eventImg;
        if (tagAction in eventToImg) {
            eventImg = eventToImg[tagAction];
        } else {
            eventImg = ImageMisc;
        }

        let className = "clip-list-entry";
        if (clip.key() === this.props.currentEditKey) {
            className += " active";
        }

        return (
            <tr key={clip.key()}
                className={className}
                onClick={() => this.props.onClick(clip)}>
                <td>
                    <span className="text-left">
                        { clip.gameTimeString() }
                    </span>
                    <span className="text-left">
                        { clip.gameString() }
                    </span>
                    <span className="text-center">
                        <div className={"star-rating rating-" + rating}>{rating}</div>
                    </span>
                    <span className="text-right">
                        { timeAgoString(clip.timestamp) }
                    </span>
                    <span className="text-left">
                        <img height="17px" src={eventImg} alt="tag icon"/>
                    </span>
                    <span className="text-left">
                        { clip.toString() }
                    </span>
                    <span className="text-right">
                        {missingExpectedFields.length > 0 && (
                            <span style={{color:"red"}}
                                  title={"Missing " + missingExpectedFields.join(", ")}
                                  className={"glyphicon glyphicon-asterisk"} />
                        )}
                    </span>
                </td>
            </tr>
        );
    }

    @bind
    handleFilterTagChange(e) {
        let {value} = e.target;
        this.setState({tagFilter: value}, () => this.forceRefresh());
    }

    @bind
    handleFilterRatingChange(e) {
        let {value} = e.target;
        this.setState({minRatingFilter: parseInt(value, 10)}, () => this.forceRefresh());
    }

    @bind
    setpage (page) {
        this.setState({page: page}, () => this.forceRefresh());
    }

    render () {
        let headerButtons = undefined;
        if (this.props.eventFilteringEnabled) {
            headerButtons = (
                <span>
                    <label htmlFor="rating-filter-select">Stars:</label>
                    <select id="rating-filter-select" onChange={this.handleFilterRatingChange}>
                        <option value={1}>1+</option>
                        <option value={2}>2+</option>
                        <option value={3}>3+</option>
                        <option value={4}>4+</option>
                        <option value={5}>5+</option>
                    </select>
                    <label htmlFor="tag-filter-select">Tag:</label>
                    <select id="tag-filter-select" onChange={this.handleFilterTagChange}>
                        {this.state.filterTags.map((t) =>
                            (<option key={t} value={t}>{t}</option>))}
                    </select>
                </span>
            );
        } else if (this.props.onCreateNewClip) {
            headerButtons = (
                <span className="input-group-button">
                    <button
                        className="btn btn-sm btn-default"
                        title="Create new event"
                        onClick={this.props.onCreateNewClip}>
                        Create new
                    </button>
                </span>
            );
        }

        return (
            <div className="row">
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th colSpan="2" className="clip-list-title">
                                <span>
                                    { this.props.title }
                                </span>
                                <span className="pull-right">
                                    {headerButtons}
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        { this.state.clips.map(this.formatClip) }
                    </tbody>
                </table>
                {this.state.maxPages > 1 && (
                    <div className="clip-list-pagination">
                        <Pagination
                            first={this.state.page > 1}
                            bsSize="small"
                            maxButtons={3}
                            onSelect={this.setpage}
                            items={this.state.maxPages}
                            activePage={this.state.page}
                        />
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/ClipList.js